import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import LoginPage from './components/pages/LoginPage';
import MainPage from './components/pages/MainPage';
import 'antd/dist/antd.css';
import 'react-grid-layout/css/styles.css';
import './App.css';
import cookie from 'react-cookies';

class App extends Component {
	constructor(props) {
		super(props);
		this.basename = process.env.REACT_APP_BASENAME;
		this.getCookie = this.getCookie.bind(this);
	}

	state = { user: null, collapsed: true };

	componentDidMount(){
		this.getCookie();
	}

	 getCookie(djutyid,djutyname) {
	 	  

	   var djutyuser = cookie.load('djutyuser')
 	   // var userName = cookie.load('djutyname')
 	   console.log('userId_qwery',djutyuser); 
 	   // console.log('userId_djutyname',userName);

 	   if(djutyuser != undefined &&  djutyuser != null && djutyuser !='' ){
           this.setState({ user: djutyuser });
           this.setState({ isLogged: true });
        }
        else{
        	 this.setState({ isLogged: false });
        }
 	}

	render() {
		return (
			<Router basename={this.basename}>
				<div>
					<Switch>
						<Route exact={true} path="/" render={props => this.renderMainPage()} />
						<Route exact={true} path="/register" render={props => <LoginPage user={this.state.user} />} />
						<Route path="/goals" render={props => this.redirectWhenLoggedOut()} />
						<Route path="/assumptions" render={props => this.redirectWhenLoggedOut()} />
						<Route path="/journeys" render={props => this.redirectWhenLoggedOut()} />
						<Route path="/forecast" render={props => this.redirectWhenLoggedOut()} />
						<Route path="/revenue" render={props => this.redirectWhenLoggedOut()} />
						<Route path="/persona" render={props => this.redirectWhenLoggedOut()} />
						<Route path="/account" render={props => this.redirectWhenLoggedOut()} />
						<Route path="/users" render={props => <MainPage user={this.state.user} onUpdate={this.onUpdate.bind(this)} />} />
						<Route path="/logout" render={props => this.renderLogout()} />
					</Switch>
				</div>
			</Router>
		);
	}

	renderLogout() {
		this.setState({ user: null });
		return <Redirect to="/" />;
	}

	redirectWhenLoggedOut() {
		return this.state.user ? <MainPage user={this.state.user} onUpdate={this.onUpdate.bind(this)} /> : <Redirect to="/" />;
	}

	renderMainPage() {
		return this.state.user ? <MainPage user={this.state.user} onUpdate={this.onUpdate.bind(this)} /> : <LoginPage user={this.state.user} onUpdate={this.onUpdate.bind(this)} />;
	}

	onUpdate(user) {
		this.setState({ user });
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js